exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".v-card.v-card.v-card--account{border-color:currentColor;border-width:4px}.v-card.v-card.v-card--account .v-icon{color:inherit}.v-card--account,.v-card--account:before{border-radius:50%}", ""]);

// exports
